import { ApiClient, GetResponseType } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';

function getGAClientId() {
  const cookie = document.cookie.split('; ').find((row) => row.startsWith('_ga='));

  if (!cookie) return null;

  const value = cookie.split('=')[1];
  // Example: "GA1.1.1234567890.1691234567"

  const parts = value.split('.');

  if (parts.length < 4) return null;

  // client_id = last two parts joined by dot
  return `${parts[2]}.${parts[3]}`;
}

export const collect = async (payload: any): Promise<GetResponseType<any>> => {
  const clientId = getGAClientId();

  return await ApiClient.post(
    `${window.config.api_endpoint}/collect`,
    { ...payload, client_id: clientId },
    WITH_AUTH
  );
};
